import documentService from 'resources/document/document.service';

import * as storageService from 'services/storage.service';

const copyDocument = async ({
  copyDocumentId,
  filePath,
  companyId,
  taskId, dealId, clientId, templateId,
  uploaderId,
  type,
}) => {
  const documentToCopy = await documentService.findById(copyDocumentId);

  const documentToCopyBucket = documentToCopy.file_url.substr(0, documentToCopy.file_url.indexOf('/'));
  const documentToCopyPath = documentToCopy.file_url.substring(documentToCopy.file_url.indexOf('/') + 1);

  const toPath = `${filePath}/${documentToCopy.name}`;
  const fileUrl = `${documentToCopyBucket}/${toPath}`;

  // First, create the document record
  const documentResponse = await documentService.create({
    name: documentToCopy.name,
    file_url: fileUrl,
    company_id: companyId,
    uploader_id: uploaderId,
    ...(dealId && { deal_id: dealId }),
    ...(taskId && { task_id: taskId }),
    ...(clientId && { client_id: clientId }),
    ...(templateId && { template_id: templateId }),
    ...(type && { type }),
  });

  if (!documentResponse?.data?.[0])
    return null;

  // If document creation is successful, proceed with file copy
  await storageService.copyFile({
    bucket: documentToCopyBucket,
    fromPath: documentToCopyPath,
    toPath,
  });

  return documentResponse.data[0];
};

export {
  copyDocument,
};
